export const INIT_FULL_CLEANED_FILE_URL = 'INIT_FULL_CLEANED_FILE_URL';

export function initFullCleanedFileURL(fullCleanedFileURL){
    return{
        type: INIT_FULL_CLEANED_FILE_URL,
        mainState: {
            fullCleanedFileURL: fullCleanedFileURL
        }
    }
}